export const FakeUSDCAddress = "0x0087Df71604cC4433741dc3c1830b1D0448c4c99";
